<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div v-if="orderType && restaurantId"
       :class="$style.dropdown"
       offset-y>
    <button :class="$style.headerStore"
            @click="clickRestaurantHandler">
      <svg v-svg
           :class="$style.headerStoreIcon"
           symbol="store-icon"/>
      <span :class="$style.headerText">
        <span :class="$style.headerStoreName">{{ restTitle }}</span>
        {{ orderTypeTitle }}
      </span>
      <div :class="$style.headerDownWrapper">
        <svg v-svg
             :class="$style.headerDownIcon"
             symbol="chevron-down"/>
      </div>

    </button>

    <CommonModal :display="showAbandonModal"
                 :always-modal="true"
                 width="480"
                 type="AppendModal"
                 title="Abandon Boss Creation?"
                 name="linkSent"
                 @toggleModal="cancelHandler">
      <ConfirmModalContent
        message="Are you sure you want to abandon this creation?"
        confirm-text="Yes, ABANDON"
        cancel-text="NO"
        @confirm="confirmHandler"
        @cancel="cancelHandler"/>
    </CommonModal>

    <CommonModal :display="showCancelOrderModal"
                 :always-modal="true"
                 width="480"
                 type="AppendModal"
                 title="Cancel Order?"
                 name="cartOrderCancel"
                 @toggleModal="cancelOrderCancellingHandler">
      <ConfirmModalContent
        message="Are you sure you want to cancel your entire order?"
        confirm-text="YES, CANCEL"
        cancel-text="NO"
        @confirm="cancelOrder"
        @cancel="cancelOrderCancellingHandler"/>
    </CommonModal>
  </div>
</template>

<script>
import Component from 'vue-class-component';
import { Getter, Action } from 'vuex-class';
import Vue from 'vue';
import ConfirmModalContent from '@/components/ConfirmModalContent';
import CommonModal from '@/apps/shared/components/CommonModal';
import { ORDER_TYPES } from '@/config/constants';
import { CONFIGURATOR_CLEAR } from '@/apps/configurator/store/types';
import { CART_ITEM_REMOVE, CART_RESET } from '@/apps/cart/store/types';

/**
 * Component to go to main menu.
 */
@Component({
  components: {
    CommonModal,
    ConfirmModalContent,
  },
})
export default class DesktopRestaurantButton extends Vue {
  @Getter orderType;
  @Getter restaurantId;
  @Getter rests;
  @Getter orderItemCompleted;
  @Getter order;
  @Action(CONFIGURATOR_CLEAR) clearConfigurator;
  @Action(CART_ITEM_REMOVE) cartRemoveItem;
  @Action(CART_RESET) cartReset;

  showAbandonModal = false;
  showCancelOrderModal = false;

  /**
   * Get string representation for order type
   */
  get orderTypeTitle() {
    if (this.orderType === ORDER_TYPES.inStore) {
      return 'In store';
    }

    if (this.orderType === ORDER_TYPES.curbside) {
      return 'Curbside';
    }

    return '';
  }

  /**
   * Get string representation for order type
   */
  get restTitle() {
    if (!this.restaurantId) {
      return '';
    }

    let selectedRestName = '';

    this.rests.forEach((item) => {
      if (item.id === this.restaurantId) {
        selectedRestName = item.name;
      }
    });

    return selectedRestName;
  }

  /**
   * handler for click on Restaurant button
   */
  clickRestaurantHandler() {
    if (!this.orderItemCompleted) {
      this.openAbandonModal();

      return;
    }

    if (this.order && this.orderItemCompleted) {
      this.openCancelOrderModal();

      return;
    }

    this.goToMainPage();
  }

  /**
   * Method for opening abandon modal
   */
  openAbandonModal() {
    this.showAbandonModal = true;
  }

  /**
   * Method for opening cancel order modal
   */
  openCancelOrderModal() {
    this.showCancelOrderModal = true;
  }

  /**
   * Handler for confirm abandon
   */
  confirmHandler(value) {
    this.showAbandonModal = value;
    if (!this.orderItemCompleted) {
      this.cartRemoveItem(this.orderItemId);
    }
    this.goToMainPage();
  }

  /**
   * Handler for confirm cancelling order
   */
  cancelOrder() {
    this.cartReset();
    this.goToMainPage();
  }

  /**
   * Handler for cancel abandon
   */
  cancelHandler() {
    this.showAbandonModal = false;
  }

  /**
   * Handler for cancel cancelling order
   */
  cancelOrderCancellingHandler() {
    this.showCancelOrderModal = false;
  }

  /**
   * helper for navigation to menu
   */
  goToMainPage() {
    this.$router.push({ name: 'main' });
  }
}
</script>

<style lang="scss" module>
@import "~@/style/variables.scss";

.headerText {
  font-family: 'Gotham', sans-serif;
  font-size: 15px;
  font-weight: 300;
  letter-spacing: -0.36px;
  line-height: 20px;
  text-align: left;
  color: $white;
  margin: 0 10px;
}

.headerStore {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0 24px;
  border-right: 1px solid $white-transparent;
  outline: none;

  .headerStoreIcon {
    width: 37px;
    height: 37px;
  }
}

.headerText {
  margin-right: 24px;

  .headerStoreName {
    display: block;
    font-family: 'Gotham', sans-serif;
    font-weight: 700;
    font-size: 15px;
  }
}

.headerDownIcon {
  width: 12px;
  height: 7px;
  fill: $white;
}

.dropdown {
  z-index: 30;
}

.dropdownMenu {
  border-top: 4px solid $green-color;
  margin-top: 15px;
  overflow-y: hidden;
}

.dropdownItem {
  height: 36px;
}

.dropdownTitle {
  font-family: 'Gotham', sans-serif;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.21px;
  font-weight: 700;
  color: $black;
}

.headerDownWrapper {
  transform: rotateZ(-90deg);
}

@media screen and (max-width: 900px) {
  .headerText,
  .headerDownIcon {
    display: none;
  }

  .headerLogin .headerLoginIcon {
    width: 32px;
    height: 32px;
  }
}

@media screen and (max-width: 530px) {
  .headerLogin,
  .headerStore {
    padding-right: 16px;
  }

  .headerCart {
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/desktop/components/DesktopRestaurantButton.vue